// src/util/hooks/ThemeContext.js
import React, { createContext, useState, useMemo } from "react";
import { ThemeProvider, createMuiTheme, CssBaseline } from "@material-ui/core";

// Crear el contexto
export const ThemeContext = createContext();

const ThemeContextProvider = ({ children }) => {
  // Recuperar del localStorage o default
  const [mode, setMode] = useState(localStorage.getItem("theme") || "light");

  // Cambiar entre claro y oscuro
  const toggleTheme = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("theme", newMode);
  };

  // Crear el tema dinámico
  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: mode, // 👈 En MUI v4 se usa "type"
          primary: {
            main: mode === "light" ? "#1976d2" : "#90caf9",
          },
          secondary: {
            main: mode === "light" ? "#f50057" : "#f48fb1",
          },
          background: {
            default: mode === "light" ? "#f5f5f5" : "#121212",
            paper: mode === "light" ? "#ffffff" : "#1e1e1e",
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
